import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import '@ingka/variables/design-tokens.css';
import '@ingka/hyperlink/style.scss';
import '@ingka/svg-icon/style.scss';
import '@ingka/button/style.scss';
import '@ingka/focus/style.scss';
import '@ingka/loading/style.scss';
import '@ingka/forms/style.scss';
import '@ingka/choice/style.scss';
import '@ingka/inline-message/style.scss';
import '@ingka/aspect-ratio-box/style.scss';
import '@ingka/image/style.scss';
import '@ingka/breadcrumb/style.scss';
import '@ingka/modal/style.scss';
import '@ingka/status/style.scss';
import '@ingka/carousel/style.scss';
import '@ingka/price/style.scss';
import "@ingka/rating/style.scss";
import "@ingka/commercial-message/style.scss";
import "@ingka/price-module/style.scss";
import "@ingka/quantity-stepper/style.scss";
import './styles/style.scss';
import * as sentry from './sentry';

sentry.init();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
